import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MESSAGE_KEYS_BY_CADENCE = {
  DAILY: {
    summary: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.daily.summary',
    totalCount: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.daily.totalCount',
    totalCountBefore: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.daily.totalCountBefore',
    percentageChange: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.daily.percentageChange',
    percentIncreased: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.daily.percentIncreased',
    percentDecreased: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.daily.percentDecreased',
    percentDifference: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.daily.percentDifference',
    zeroPercent: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.daily.zeroPercent',
    includedEmail: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.daily.includedEmail',
    emailSent: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.daily.emailSent'
  },
  WEEKLY: {
    summary: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.weekly.summary',
    totalCount: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.weekly.totalCount',
    totalCountBefore: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.weekly.totalCountBefore',
    percentageChange: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.weekly.percentageChange',
    percentIncreased: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.weekly.percentIncreased',
    percentDecreased: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.weekly.percentDecreased',
    percentDifference: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.weekly.percentDifference',
    zeroPercent: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.weekly.zeroPercent',
    includedEmail: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.weekly.includedEmail',
    emailSent: 'settingsV2.enrollmentNotificationSetting.v2.howItWorks.weekly.emailSent'
  }
};
const EnrollmentNotificationSettingsHelpTooltip = ({
  cadence
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: MESSAGE_KEYS_BY_CADENCE[cadence].summary
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      styled: true,
      children: [/*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: MESSAGE_KEYS_BY_CADENCE[cadence].emailSent
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: MESSAGE_KEYS_BY_CADENCE[cadence].totalCount
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: MESSAGE_KEYS_BY_CADENCE[cadence].percentDifference
        })
      }), /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: MESSAGE_KEYS_BY_CADENCE[cadence].zeroPercent
        })
      })]
    })]
  });
};
export default EnrollmentNotificationSettingsHelpTooltip;